import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {AddressWrapped} from '@onegovbugs/onegov-react-components';
import Button from "../../components/common/button/Button";
import styles from "./DeceasedDetails.module.scss";
import DefaultLayout from "../../layouts/DefaultLayout";
import Warning from "../../components/common/warning/Warning";
import ErrorMsg from "../../components/common/error/ErrorMsg";
import RadioSelector from "../../components/common/radioSelector/RadioSelector";
import {storePersonData, validatePerson, getInfo} from "../../redux/actions";
import moment from "moment";
import AddressInput from "../../components/common/addressInput/AddressInput";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip';

const DeceasedDetails = props => {
  const [errors, setErrors] = useState({
    state: false,
    birthsMarriage: false,
    certificateNum: false,
    firstname: false,
    lastname: false,
    otherName: false,
    dateOfBirth: false,
    dateOfDeath: false,
    residingNursingHome: false,
  });

  const dispatch = useDispatch();
  const personData = useSelector(state => state.person);
  const robotData = useSelector(state => state.robot);

  useEffect(() => {
    if(!robotData.notARobot) {
      props.history.push('/')
    }
  }, []);

  const [deceasedState, setDeceasedState] = useState(personData.deceasedState);
  const [birthCertificateIssued, setBirthCertificateIssued] = useState(personData.birthCertificateIssued);
  const [otherNames, setOtherNames] = useState(personData.otherNames);
  const [certificateLongNum, setCertificateLongNum] = useState(personData.certificateLongNum);
  const [certificateShortNum, setCertificateShortNum] = useState(personData.certificateShortNum);
  const [dayOfBirth, setDayOfBirth] = useState(personData.dayOfBirth);
  const [monthOfBirth, setMonthOfBirth] = useState(personData.monthOfBirth);
  const [yearOfBirth, setYearOfBirth] = useState(personData.yearOfBirth);
  const [birthEntered, setBirthEntered] = useState(false);
  const [certificateEntered, setCertificateEntered] = useState(false);
  const [dayOfDeath, setDayOfDeath] = useState(personData.dayOfDeath);
  const [monthOfDeath, setMonthOfDeath] = useState(personData.monthOfDeath);
  const [yearOfDeath, setYearOfDeath] = useState(personData.yearOfDeath);
  const [deathEntered, setDeathEntered] = useState(false);
  const [firstname, setFirstname] = useState(personData.firstname);
  const [middlename, setMiddlename] = useState(personData.middlename);
  const [lastname, setLastname] = useState(personData.lastname);
  const [otherName, setOtherName] = useState(personData.otherName);
  const [residingNursingHome, setResidingNursingHome] = useState('no');
  const iniNursingHome = {
    value: null,
    label: 'Select the nursing home'
  }
  const [nursingHome, selectNursingHome] = useState(personData.nursingHome || iniNursingHome);
  const [currentAddress, setCurrentAddress] = useState(personData.currentAddress);
  const [isAddressValid, setIsAddressValid] = useState(false);
  const [isAddressValidating, setAddressValidating] = useState(false);
  const [warnPartialMatch, setWarnPartialMatch] = useState(false);

  useEffect(() => {
    if (!birthEntered)
      return;
    const e2 = {...errors};
    e2.dateOfBirth = isDateOfBirthValid();
    setErrors(e2);
  }, [dayOfBirth, monthOfBirth, yearOfBirth, birthEntered]);

  useEffect(() => {
    if (!certificateEntered)
      return;
    const e2 = {...errors};
    e2.certificateNum = isCertificateValid();
    setErrors(e2);
  }, [certificateLongNum, certificateShortNum, certificateEntered]);

  useEffect(() => {
    if (!deathEntered)
      return;
    const e2 = {...errors};
    e2.dateOfDeath = isDateOfDeathValid();
    e2.deathBeforeBirth = isDeathBeforeBirth();
    setErrors(e2);
  }, [dayOfDeath, monthOfDeath, yearOfDeath, deathEntered]);

  const storeAndSubmitData = () => {
    dispatch(storePersonData({
      firstname, middlename, lastname, deceasedState, birthCertificateIssued, otherNames,
      certificateLongNum, certificateShortNum, dayOfBirth, monthOfBirth, yearOfBirth,
      dayOfDeath, monthOfDeath, yearOfDeath, otherName, residingNursingHome, nursingHome,
      currentAddress
    }));
    dispatch(validatePerson(firstname, middlename,
      lastname, moment(`${parseInt(dayOfBirth)}-${parseInt(monthOfBirth)}-${parseInt(yearOfBirth)}`,
        "D-M-YYYY").format("MM/DD/YYYY"),moment(`${parseInt(dayOfDeath)}-${parseInt(monthOfDeath)}-${parseInt(yearOfDeath)}`,
        "D-M-YYYY").format("MM/DD/YYYY")));
  };

  useEffect(() => {
    dispatch(getInfo());
    console.log("APP BASE: ", process.env.REACT_APP_BASE_URL);
  }, []);

  const clearErrors = (errs) => {
    const e2 = {...errors};
    errs.forEach(errName => e2[errName] = false);
    setErrors(e2);
  }

  const clearError = (errName) => {
    const e2 = {...errors};
    e2[errName] = false;
    setErrors(e2);
  }

  const isCertificateValid = () => {
    return birthCertificateIssued === "yes" && (certificateLongNum === null || certificateShortNum === null ||
      (certificateLongNum !== null && (isNaN(certificateLongNum) || certificateLongNum.length !== 8) ||
        certificateShortNum !== null && (isNaN(certificateShortNum) || certificateShortNum.length !== 4)));
  }

  const isDateOfBirthValid = () => {
    return dayOfBirth === null || isNaN(dayOfBirth) ||
      monthOfBirth === null || isNaN(monthOfBirth) ||
      yearOfBirth === null || isNaN(yearOfBirth) || yearOfBirth < 1900 ||
      ((dayOfBirth !== null && monthOfBirth !== null && yearOfBirth !== null) ?
        !moment(`${yearOfBirth}-${monthOfBirth}-${dayOfBirth}`).isValid() ||
        moment(`${yearOfBirth}-${monthOfBirth}-${dayOfBirth}`).isAfter(moment()) : false);
  }

  const isDateOfDeathValid = () => {
    return dayOfDeath === null || isNaN(dayOfDeath) ||
      monthOfDeath === null || isNaN(monthOfDeath) ||
      yearOfDeath === null || isNaN(yearOfDeath) || yearOfDeath < 1900 ||
      ((dayOfDeath !== null && monthOfDeath !== null && yearOfDeath !== null) ?
        !moment(`${yearOfDeath}-${monthOfDeath}-${dayOfDeath}`).isValid() ||
        moment(`${yearOfDeath}-${monthOfDeath}-${dayOfDeath}`).isAfter(moment()) : false);
  }

  const isDeathBeforeBirth = () => {
    const birth = moment(`${yearOfBirth}-${monthOfBirth}-${dayOfBirth}`);
    const death = moment(`${yearOfDeath}-${monthOfDeath}-${dayOfDeath}`);
    return birth.isValid() && death.isValid() && yearOfDeath > 1900
      && yearOfBirth > 1900 && death.isBefore(birth);
  }

  const isValid = () => {
    const e2 = {...errors};
    e2.state = deceasedState === null;
    e2.birthsMarriage = birthCertificateIssued === null;
    e2.certificateNum = isCertificateValid();
    e2.firstname = firstname === null || (firstname !== null && firstname.length < 2);
    e2.lastname = lastname === null || (lastname !== null && lastname.length < 2);
    e2.otherName1 = otherNames === null;
    e2.otherName2 = otherNames === 'yes' && (otherName === null || otherName.length < 2);
    e2.dateOfBirth = isDateOfBirthValid();
    e2.dateOfDeath = isDateOfDeathValid();
    e2.deathBeforeBirth = isDeathBeforeBirth();
    // e2.residingNursingHome = residingNursingHome === null;
    e2.currentAddress = residingNursingHome === 'no' && !isAddressValid;
    // e2.nursingHome = residingNursingHome === 'yes' && (!nursingHome || !nursingHome.value);

    const isNotValid = Object.keys(e2).reduce((accum, key) => accum || e2[key], false);
    setErrors(e2);

    return !isNotValid;
  };

  const changeDateValue = (event, setFunction, errName, length) => {
    if (event.target.value.length > length) {
      return
    }
    clearError(errName);
    const val = event.target.value.replace(/\D/g, '');
    setFunction(val);
  }

  const addressRef = useRef();

  return <DefaultLayout>
    <div className={styles.mainCont}>
      <div className={'row'}>
        <div className={'col-12'}>
          <h2>Details of the person who has died</h2>
          <Warning type={'warning'} title={'This service is in BETA for NSW, QLD, VIC and SA only.'}
                   description={`To be eligible to notify ANZ using this service, 
a NSW, QLD, VIC or SA Death Certificate needs to have been issued for the person who has died.`}/>
        </div>
        <div className={`col-12 ${styles.firstTitle}`}>
          <RadioSelector
            title={'State where the person died'}
            options={[
              {
                value: 'NSW',
                label: 'NSW'
              },
              {
                value: 'QLD',
                label: 'QLD'
              },
              {
                value: 'VIC',
                label: 'VIC'
              },
              {
                value: 'SA',
                label: 'SA'
              }
            ]}
            initialValue={deceasedState}
            onSelectionChange={(val) => {
              clearError('state');
              setDeceasedState(val);
            }}
          />
        </div>
        {errors.state ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'Please select the state where the person died.'}
            />
          </div> : null}
        <div className={`col-12 ${styles.firstTitle}`}>
          <RadioSelector
            title={'Has a Births Deaths and Marriages Death Certificate been issued for the person who has died?'}
            id={'certificate'}
            tooltip = {<div className={styles.tooltipCont}>
              This is a requirement for this service. You don’t<br/>
              need to have it in your possession to complete<br/>
              the notification.
            </div>}
            options={[
              {
                value: 'yes',
                label: 'Yes'
              },
              {
                value: 'no',
                label: 'No'
              }
            ]}
            initialValue={birthCertificateIssued}
            onSelectionChange={(val) => {
              if (val === 'no') {
                setCertificateLongNum(null);
                setCertificateShortNum(null);
              }
              clearError('birthsMarriage');
              setBirthCertificateIssued(val);
            }}
          />
        </div>
        {errors.birthsMarriage ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'Please select an option.'}
            />
          </div> : null}
        {birthCertificateIssued === "yes" ?
          <div className={'col-12'}>
            <div className={`${styles.tooltipedHeader} clearfix`}>
              <h3>
                What is the Registration Number on the Death Certificate?
                <FontAwesomeIcon
                  className={styles.infoTooltipCont}
                  icon={faInfoCircle}
                  size="lg"
                  data-tip="React-tooltip"
                  data-for={`rt-1`}
                />
                <ReactTooltip place="bottom" type="info" effect="float" id={'rt-1'}>
                  <div className={styles.tooltipCont} >
                    This can be found on the top right<br/>
                    of the Death Certificate
                  </div>
                </ReactTooltip>
              </h3>
            </div>
            <p className={styles.smallParagraph}>Death Certificate Registration Number</p>
            <input
              className={`${styles.inputBox} ${styles.inputBoxInlineLarge}`}
              placeholder={'00000000'}
              value={certificateLongNum}
              onChange={(event) => {
                if (event.target.value.length > 8) {
                  return
                }
                const val = event.target.value.replace(/\D/g, '');
                clearError('certificateNum');
                setCertificateLongNum(val);
              }}
              onFocus={() => {
              }}
            />
            <span className={`${styles.separatorBar}`}>/</span>
            <input
              className={`${styles.inputBox} ${styles.inputBoxInlineSmall}`}
              placeholder={'0000'}
              value={certificateShortNum}
              onChange={(event) => {
                if (event.target.value.length > 4) {
                  return
                }
                const val = event.target.value.replace(/\D/g, '');
                clearError('certificateNum');
                setCertificateShortNum(val)
              }}
              onBlur={() => {
                setCertificateEntered(true);
              }}
            />
          </div> : null}
        {errors.certificateNum ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'Death Certificate Registration Number is not valid, please enter 8 digits, then 4 digits'}
            />
          </div> : null}
        <div className={'col-12'}>
          <h3>Name of the person who has died</h3>
        </div>
        <div className={'col-12 col-sm-4'}>
          <p className={styles.smallParagraph}>Given/First Name</p>
          <input
            className={`${styles.inputBox}`}
            placeholder={'Given/First Name'}
            value={firstname}
            onChange={(event) => {
              clearError('firstname');
              setFirstname(event.target.value)
            }}
          />
        </div>
        <div className={'col-12 col-sm-4'}>
          <p className={styles.smallParagraph}>Middle Name (optional)</p>
          <input
            className={`${styles.inputBox}`}
            placeholder={'Middle Name (optional)'}
            value={middlename}
            onChange={(event) => setMiddlename(event.target.value)}
          />
        </div>
        <div className={'col-12 col-sm-4'}>
          <p className={styles.smallParagraph}>Family/Last Name</p>
          <input
            className={`${styles.inputBox}`}
            placeholder={'Family/Last Name'}
            value={lastname}
            onChange={(event) => {
              clearError('lastname');
              setLastname(event.target.value);
            }}
          />
        </div>
        {errors.firstname || errors.lastname ?
          <div className={`col-12 ${styles.errorContainer}`}>
            {errors.firstname ?
              <ErrorMsg
                type={"error"}
                description={'First name is required'}
              />
              : null}
            {errors.lastname ?
              <ErrorMsg
                type={"error"}
                description={'Last name is required'}
              />
              : null}
          </div> : null}
        <div className={'col-12'}>
          <RadioSelector
            title={'Was the person known by any other names?'}
            options={[
              {
                value: 'yes',
                label: 'Yes'
              },
              {
                value: 'no',
                label: 'No'
              }
            ]}
            initialValue={otherNames}
            onSelectionChange={(val) => {
              clearError('otherName1');
              setOtherNames(val);
            }}
          />
        </div>
        {otherNames === 'yes' ?
          <div className={'col-12'}>
            <p className={`${styles.smallParagraph} ${styles.smallParagraphMarginTop}`}>Other names</p>
            <input
              className={`${styles.inputBox}`}
              placeholder={'Other names'}
              value={otherName}
              onChange={(event) => {
                clearError('otherName2');
                setOtherName(event.target.value);
              }}
            />
          </div> : null}
        {errors.otherName1 || errors.otherName2 ?
          <div className={`col-12 ${styles.errorContainer}`}>
            {errors.otherName1 ?
              <ErrorMsg
                type={"error"}
                description={'Please indicate if the person was known by any other name.'}
              />
              : null}
            {errors.otherName2 ?
              <ErrorMsg
                type={"error"}
                description={'If the person was known by other name, that other name is required.'}
              />
              : null}
          </div> : null}
        <div className={'col-12'}>
          <h3>Date of birth</h3>
          <div className={'clearfix'}>
            <div className={styles.dayMonthSpace}>
              <p className={styles.smallParagraph}>Day</p>
              <input
                className={`${styles.inputBox}`}
                placeholder={'DD'}
                value={dayOfBirth}
                onChange={(e) => changeDateValue(e, setDayOfBirth, 'dateOfBirth', 2)}
              />
            </div>
            <div className={styles.dayMonthSpace}>
              <p className={styles.smallParagraph}>Month</p>
              <input
                className={`${styles.inputBox}`}
                placeholder={'MM'}
                value={monthOfBirth}
                onChange={(e) => changeDateValue(e, setMonthOfBirth, 'dateOfBirth', 2)}
              />
            </div>
            <div className={styles.yearSpace}>
              <p className={styles.smallParagraph}>Year</p>
              <input
                className={`${styles.inputBox}`}
                placeholder={'YYYY'}
                value={yearOfBirth}
                onChange={(e) => changeDateValue(e, setYearOfBirth, 'dateOfBirth', 4)}
                onBlur={() => {
                  setBirthEntered(true);
                }}
              />
            </div>
          </div>
        </div>
        {errors.dateOfBirth ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'Date of birth is invalid.'}
            />
          </div> : null}
        <div className={'col-12'}>
          <h3>Date of death</h3>
          <div className={'clearfix'}>
            <div className={styles.dayMonthSpace}>
              <p className={styles.smallParagraph}>Day</p>
              <input
                className={`${styles.inputBox}`}
                placeholder={'DD'}
                value={dayOfDeath}
                onChange={(e) => changeDateValue(e, setDayOfDeath, 'dateOfDeath', 2)}
              />
            </div>
            <div className={styles.dayMonthSpace}>
              <p className={styles.smallParagraph}>Month</p>
              <input
                className={`${styles.inputBox}`}
                placeholder={'MM'}
                value={monthOfDeath}
                onChange={(e) => changeDateValue(e, setMonthOfDeath, 'dateOfDeath', 2)}
              />
            </div>
            <div className={styles.yearSpace}>
              <p className={styles.smallParagraph}>Year</p>
              <input
                className={`${styles.inputBox}`}
                placeholder={'YYYY'}
                value={yearOfDeath}
                onChange={(e) => changeDateValue(e, setYearOfDeath, 'dateOfDeath', 4)}
                onBlur={() => {
                  setDeathEntered(true);
                }}
              />
            </div>
          </div>
        </div>
        {errors.dateOfDeath || errors.deathBeforeBirth ?
          <div className={`col-12 ${styles.errorContainer}`}>
            {errors.dateOfDeath ?
              <ErrorMsg
                type={"error"}
                description={'Date of death is invalid.'}
              /> : null}
            {errors.deathBeforeBirth ?
              <ErrorMsg
                type={"error"}
                description={'Date of death can not be before Date of birth.'}
              /> : null}
          </div> : null}
        {/*<div className={'col-12'}>*/}
        {/*  <RadioSelector*/}
        {/*    title={'Was the person who has died residing in a nursing home?'}*/}
        {/*    options={[*/}
        {/*      {*/}
        {/*        value: 'yes',*/}
        {/*        label: 'Yes'*/}
        {/*      },*/}
        {/*      {*/}
        {/*        value: 'no',*/}
        {/*        label: 'No'*/}
        {/*      }*/}
        {/*    ]}*/}
        {/*    initialValue={residingNursingHome}*/}
        {/*    onSelectionChange={(val) => {*/}
        {/*      clearErrors(['residingNursingHome', 'currentAddress', 'nursingHome']);*/}
        {/*      setResidingNursingHome(val);*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</div>*/}
        {/*{residingNursingHome === 'yes' ?*/}
        {/*  <div className={`col-12 ${styles.secondarySection} ${styles.nursingHomeCont}`}>*/}
        {/*    <Dropdown*/}
        {/*      options={[*/}
        {/*        iniNursingHome,*/}
        {/*        {*/}
        {/*          value: 'Ashburn House',*/}
        {/*          label: 'Ashburn House'*/}
        {/*        },*/}
        {/*        {*/}
        {/*          value: 'Ashleigh Lodge',*/}
        {/*          label: 'Ashleigh Lodge'*/}
        {/*        }*/}
        {/*      ]}*/}
        {/*      className={styles.dropdown}*/}
        {/*      value={nursingHome}*/}
        {/*      onSelect={(val) => {*/}
        {/*        clearError('nursingHome');*/}
        {/*        selectNursingHome(val);*/}
        {/*        setCurrentAddress(null);*/}
        {/*      }}*/}
        {/*    />*/}
        {/*  </div> : null}*/}
        {/*{residingNursingHome === 'no' ?*/}
        <div className={`col-12 ${styles.addressContainer}`}>
          <AddressWrapped
            autoValidate
            label={<h3>
              What is the last known address of the person who has died?
            </h3>}
            placeholder={' '}
            baseUrl={process.env.REACT_APP_BASE_URL}
            ref={addressRef}
            onChange={(data) => {
              clearError("currentAddress");
              selectNursingHome(iniNursingHome);
              setCurrentAddress(data.address);
            }}
            value={currentAddress ?? {}}
            onValidationChange={setIsAddressValid}
            onWarningChange={setWarnPartialMatch}
            onLoading={setAddressValidating}
            aria-describedby={errors.currentAddress ? "currentAddressErrorMessage" : undefined }
            aria-invalid={`${errors.currentAddress ? "true" : "false" }`}
          />
        </div>
        {warnPartialMatch ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"warning"}
              description={'The address you entered wasn\'t found, but you can finish the application nonetheless.'}
            />
          </div> : null}
        {errors.nursingHome ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'Please select the right nursing home.'}
            />
          </div> : null}
        {errors.currentAddress ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              id={"currentAddressErrorMessage"}
              type={"error"}
              description={'Please enter the address and select the right one from the dropdown or complete all the address fields.'}
            />
          </div> : null}
        {errors.residingNursingHome ?
          <div className={`col-12 ${styles.errorContainer}`}>
            <ErrorMsg
              type={"error"}
              description={'Please indicate if the deceased resided in a nursing home.'}
            />
          </div> : null}
      </div>
      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-6 ${styles.leftCont}`}>
          <Button secondary onClick={() => {
            window.scrollTo(0, 0);
            props.history.push('/welcome')
          }}>Back</Button>
        </div>
        <div className={`col-6 ${styles.rightCont}`}>
          <Button
            disabled={isAddressValidating}
            onClick={() => {
              if (!isAddressValidating) {
                if (isValid()) {
                  storeAndSubmitData();
                  window.scrollTo(0, 0);
                  props.history.push('/match-result')
                }
              }
            }}
          >Continue</Button>
        </div>
      </div>
    </div>
  </DefaultLayout>
};

export default DeceasedDetails;
